import { z } from "zod";

import { executionSourceSchema, importLogSchema } from "../import";
import { packagingSolutionSchema } from "../packaging-solution";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

const importTimingSchema = z.object({
	overallMs: z.number(),
	importStart: z.coerce.date(),
	importEnd: z.coerce.date(),
});

const auditEventImportedDataSchema = packagingSolutionSchema.extend({
	executionSource: executionSourceSchema,
	importTiming: importTimingSchema,
	importLog: importLogSchema,
});

export const auditEventImportedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Imported),
	licensePlateNumber: z.string().nullish(),
	data: auditEventImportedDataSchema,
});

export type AuditEventImported = z.infer<typeof auditEventImportedSchema>;
